<template>
  <div id="wrapper" class="site wp-site-blocks">
    <Header/>
    <main id="inner-wrap" class="wrap kt-clear">
      <section class="entry-hero page-hero-section entry-hero-layout-standard">
        <div class="entry-hero-container-inner">
          <div class="hero-section-overlay"></div>
          <div class="hero-container site-container">
            <header class="entry-header page-title title-align-left title-tablet-align-inherit title-mobile-align-inherit">
              <h1 class="entry-title">CLT - Certified Lymphedema Therapist Directory</h1>
            </header>
          </div>
        </div>
      </section>
      <div id="content" class="content-area">
        <router-view v-show="showPage" @ready="onPageReady"/>
        <AppSpinner v-show="!showPage"/>
      </div>
    </main>
    <Footer/>
    <AppNotifications/>
  </div>
</template>

<script>
import AppNotifications from '@/base/AppNotifications'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import NProgress from 'nprogress'
export default {
  name: 'App',
  components: {
    AppNotifications,
    Header,
    Footer
  },
  data () {
    return {
      showPage: false
    }
  },
  methods: {
    onPageReady () {
      this.showPage = true
      NProgress.done()
    }
  },
  created () {
    NProgress.configure({
      speed: 200,
      minimum: 0.25,
      showSpinner: false
    })
    this.$router.beforeEach(() => {
      this.showPage = false
      NProgress.start()
    })
  }
}
</script>

<style scoped>

</style>
